<template>
<v-layout row>
  <!-- Timeline Navigation Drawer -->
  <v-navigation-drawer v-model="drawer" temporary fixed right dark>
    <v-card class="mx-auto" max-width="550" dark flat>
      <v-card-title class="pa-2 red lighten-1">
        <v-btn icon>
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <h3 class="title font-weight-light text-xs-center grow">{{ timelineItem.worknum }} Timeline</h3>
      </v-card-title>

      <v-card-text class="py-0">
        <h3 class="title font-weight-light text-xs-center grow">Status : {{ timelineItem.status }}</h3>
        <h4 class="title font-weight-light text-xs-center grow" v-if="timelineItem.status ==='In Factory'">Due W/C: {{timelineItem.deliverydate| moment("w")}}</h4>
        <h4> {{timelineItem.notes}}</h4>
        <h4> {{timelineItem.notes2}}</h4>
        <h4>{{timelineItem.jobNotes}}</h4>
        <v-timeline align-top dense>
          <v-timeline-item color="teal" small>
            <v-layout pt-3>
              <v-flex xs4>
                <strong>Created</strong>
              </v-flex>
              <v-flex>
                <strong>{{timelineItem.createdBy}}</strong>
                <div class="caption">{{timelineItem.date}}</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="teal" small v-for="(keys,values) in timelineItem.objects" v-bind:key="values">
            <v-layout pt-3>
              <v-flex xs4>
                <strong>{{values}}</strong>
              </v-flex>
              <v-flex>
                <strong></strong>
                <!--<div class="caption">{{Object.values(keys)[0]}}</div> -->
                <div class="caption">{{Object.values(keys)[1]}}</div>
                <div class="caption">{{Object.values(keys)[2]}}</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="teal" small v-if="timelineItem.status ==='Delivered'">
            <v-layout pt-3>
              <v-flex xs4>
                <strong>{{timelineItem.status}}</strong>
              </v-flex>
              <v-flex>
                <strong>{{timelineItem.deliveredAt}}</strong>
                <strong>{{timelineItem.deliveredBy}}</strong>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="teal" small v-if="timelineItem.invoiceNum !=' '">
            <v-layout pt-3>
              <v-flex xs4>
                <strong>{{timelineItem.invoiceNum}}</strong>
              </v-flex>
              <v-flex>
                <div class="caption"><strong>{{timelineItem.invoicedAt}}</strong></div>
                <div class="caption"> <strong>By: {{timelineItem.invoicedBy}}</strong></div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
    <!-- End of Timeline Navigation Drawer -->
  </v-navigation-drawer>

  <v-flex grow pa-1 mt-1>
      <!-- CRUD table -->
      <v-card>
        <v-card-title class="primary white--text">
          <!-- Date Span -->
          <span class="subtitle-2">{{ new Date() | moment("dddd, MMMM Do YYYY") }}, Week: {{ new Date() | moment("w") }}</span>
          <!-- Summary Button and Dialog -->
          <v-dialog v-model="summary" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn flat class="success mb-2 mx-2" dark v-on="on">Summary</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Summary</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout row justify-center="">
                    <v-flex xs4>
                      <v-btn left color="primary" @click="prevMonth()">
                        <v-icon dark>
                          keyboard_arrow_left
                        </v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs4>
                      <h2> Monthly Totals: {{sdate| moment("MMM YY") }}</h2>
                    </v-flex>
                    <v-flex xs4>
                      <v-btn right color="primary" @click="nextMonth()">
                        <v-icon dark>
                          keyboard_arrow_right
                        </v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout column="">
                    <h3>Total Doors Made : {{getDoors}}</h3>
                    <h3>Total Frames Made : {{getFrames}}</h3>
                    <h3>Total Other Items Made : {{getOther}}</h3>
                    <h1>{{getFSC}}</h1>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Download Data Button -->
          <v-btn class="success mb-2 mx-2">
            <download-excel :data=orders>Download Data</download-excel>
          </v-btn>
          <!-- From Date picker -->
          <v-menu ref="show_start_date" v-model="show_start_date" :close-on-content-click="false" :return-value.sync="start_date" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field dark v-model="start_date" label="From" prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="start_date" @input="filterStartDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="$refs.show_start_date.save(start_date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
          <!-- To Date picker -->
          <v-menu ref="show_end_date" v-model="show_end_date" :close-on-content-click="false" :return-value.sync="end_date" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field dark v-model="end_date" label="To" prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="end_date" @input="filterEndDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="$refs.show_end_date.save(end_date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
          <!-- Spacer -->
          <v-spacer></v-spacer>
          <!-- Search Field -->
          <v-text-field dark v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <!-- Main data table -->
        <v-data-table dense :headers="headers" :items="orders" sort-by="name" :search="search">
          <template v-slot:item.action="{ item }">
            <v-icon small class="ml-1" @click="deleteItem(item)">
              delete_forever
            </v-icon>
            <v-icon small class="ml-1" @click="restoreItem(item)">
              undo
            </v-icon>
            <v-icon small class="ml-1" @click="getInfo(item)">
              info
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
        <!-- End of CRUD table -->
      </v-card>
    </div>
  </v-flex>
</v-layout>
</template>

<script>
import moment from 'moment'
import db from '@/fb'
export default {

  data: () => ({
    dialog: false,
    show_start_date: false,
    start_date: null,

    show_end_date: false,
    end_date: null,
    filters: {
      search: '',
      added_by: '',
      start_date: null,
      end_date: null,
    },
    items: [
      'Doors',
      'Frame',
      'Timber Section',
      'Screens',
      'Glass',
      'Iron Mongory'
    ],
    sdate: moment(new Date()),
    test: '',
    summary: '',
    filterArr: [],
    isActive: true,
    search: '',
    worknum: '',
    customer: '',
    contract: '',
    product: '',
    select: '',
    //fsc:'',
    date: '',
    headers: [

      {
        text: 'Work #',
        align: 'center',
        value: 'worknum'

      },
      {
        text: 'Location',
        align: 'center',
        value: 'location'
      },
      {
        text: 'Customer',
        align: 'center',
        value: 'customer',
        sortable: false
      },
      {
        text: 'Contract',
        align: 'center',
        value: 'contract',
        sortable: false
      },
      {
        text: 'Product',
        align: 'center',
        value: 'product',
        sortable: false
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
        sortable: false
      },
      {
        text: 'FSC',
        align: 'center',
        value: 'fsc'
      },
      {
        text: 'Delivery Date',
        align: 'center',
        value: 'status',
        sortable: false
      },
      {
        text: 'Order#',
        align: 'center',
        value: 'ordernum'
      },
      {
        text: 'Invoice#',
        align: 'center',
        value: 'invoiceNum'
      },
      {
        text: 'Delivery#',
        align: 'center',
        value: 'deliveryNum'
      },
      {
        text: 'Sref',
        align: 'center',
        value: 'sref'
      },
      {
        text: 'Job Notes',
        align: 'center',
        value: 'jobnotes'
      },
      {
        text: 'Actions',
        align: 'center',
        value: 'action'
      },

    ],
    drawer: false,
    orders: [],
    orders2: [],
    editedIndex: -1,
    timelineItem: {
      worknum: '',
      customer: '',
      contract: '',
      ordernum: '',
      product: '',
      location: '',
      progress: 0,
      fsc: '',
      qty: 0,
      date: '',
      steps: null,
      timeline: null,
      createdBy: '',
    },
    editedItem: {
      worknum: '',
      customer: '',
      location: '',
      quantity: '',
      finish: '',
      inFactory: false,
      mill: false,
      mach: false,
      bench: false,
      spray: false,
      notes: ''
    },
    defaultItem: {
      worknum: '',
      customer: '',
      location: '',
      quantity: '',
      finish: '',
      inFactory: false,
      mill: false,
      mach: false,
      bench: false,
      spray: false,
      notes: ''
    }
  }),
  computed: {
    fscGet() {

    },
    getFSC() {
      var sum = 0
      var sum2 = 0
      var fsc = []
      for (var x = 0; x < this.orders.length; x++) {
        if (this.orders[x].fsc != null && this.orders[x].fsc.toLowerCase().includes("fsc")) {
          fsc.push(this.orders[x])
        }
      }
      for (var y = 0; y < fsc.length; y++) {
        if (fsc[y].product == "Doors") {
          sum += Number(fsc[y].qty)
        }
        if (fsc[y].product == "Frame") {
          sum2 += Number(fsc[y].qty)
        }
      }



      return " FSC Doors :" + sum + ", " + " FSC Frames: " + sum2 + "  -  Made this year so far"

    },
    getDoors() {
      var sum = 0
      for (var x = 0; x < this.orders.length; x++) {
        if (moment(this.orders[x].deliverydate).format("MMM YY") == moment(this.sdate).format("MMM YY")) {
          if (this.orders[x].product == 'Doors') {
            sum += Number(this.orders[x].qty)
          }
        }
      }
      return sum
    },
    getFrames() {
      var sum = 0
      for (var x = 0; x < this.orders.length; x++) {
        if (moment(this.orders[x].deliverydate).format("MMM YY") == moment(this.sdate).format("MMM YY")) {
          if (this.orders[x].product == 'Frame') {
            sum += Number(this.orders[x].qty)
          }
        }
      }
      return sum
    },
    getOther() {
      var sum = 0
      for (var x = 0; x < this.orders.length; x++) {
        if (moment(this.orders[x].deliverydate).format("MMM YY") == moment(this.sdate).format("MMM YY")) {
          if (this.orders[x].product != 'Frame' && this.orders[x].product != 'Doors' && this.orders[x].worknum != 'A00') {
            sum += Number(this.orders[x].qty)
          }
        }
      }
      return sum
    },
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    weeks() {

      for (var x = 0; x < this.orders.length; x++) {
        if (moment(this.orders[x].date).isSame(new Date(), 'week')) {
          this.filterArr.push(this.orders[x].date)
        }
      }
      return this.filterArr
    },
    history() {
      //  this.orders = this.$store.getters.history
      // return this.orders
    }

  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  mounted() {
    console.log('App mounted!');
    // this.$store.dispatch('fetchHistory')
  },
  created() {

    db.collection('history').onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === 'added') {
            this.orders.push({
              ...change.doc.data(),
              id: change.doc.id
            })

          }
        })
      }),
      db.collection('orders').onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === 'added') {
            this.orders2.push({
              ...change.doc.data(),
              id: change.doc.id
            })

          }
        })
      })

  },

  methods: {
    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);

      // Register the global standard filter.
      cf.registerFilter('search', function(searchWord, items) {
        if (searchWord.trim() === '') return items;
        return items.filter(item => {
          if ((item.fsc != null && item.fsc.toLowerCase().includes(searchWord.toLowerCase())) || item.worknum.toLowerCase().includes(searchWord.toLowerCase()) || (item.customer != undefined && item.customer.toLowerCase().includes(searchWord
              .toLowerCase()))) {
            return item
          }
          // return item.material.toLowerCase().includes(searchWord.toLowerCase());
          // return item.types.toLowerCase().includes(searchWord.toLowerCase())
        }, searchWord);
      });

      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register "start_date" filter.
      cf.registerFilter('start_date', function(start_date, items) {
        // If the filter has not been applied yet
        // just return all available items.
        if (start_date === null) return items;

        // Compare each item start_date and just return the matching ones.
        return items.filter(item => {
          return moment(item.deliverydate) >= moment(start_date);
        }, start_date);

      });

      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register "end_date" filter.
      cf.registerFilter('end_date', function(end_date, items) {
        // If the filter has not been applied yet
        // just return all available items.
        if (end_date === null) return items;

        // Compare each item end_date and just return the matching ones.
        return items.filter(item => {
          return moment(item.deliverydate) <= moment(end_date);
        }, end_date);

      });

      // Its time to run all created filters.
      // Will be executed in the order thay were defined.
      this.tempArr = cf.runFilters()
      return cf.runFilters();

    },
    /**
     * Handler when user input something at the "Filter" text field.
     */
    filterSearch(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: val
      });
    },
    /**
     * Handler when user  select some author at the "Author" select.
     */
    filterAuthor(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        added_by: val
      });
    },
    /**
     * Handler when select a date on "From" date picker.
     */
    filterStartDate(val) {
      // Close the date picker.
      this.$refs.show_start_date.save(val);

      //Convert the value to a timestamp before saving it.
      const timestamp = new Date(val + 'T00:00:00Z').getTime();
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        start_date: timestamp
      });
    },

    /**
     * Handler when select a date on "To" date picker.
     */
    filterEndDate(val) {
      // Close the date picker.
      this.$refs.show_end_date.save(val);

      //Convert the value to a timestamp before saving it.
      const timestamp = new Date(val + 'T00:00:00Z').getTime();
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        end_date: timestamp
      });
    },
    filters: {
      /**
       * Format a timestamp into date
       *
       * @param value
       * @returns {string}
       */
      formatDate: function(value) {
        if (!value) return '';
        return new Date(value).toLocaleDateString("en-GB");
      }
    },

    prevMonth() {
      this.sdate = moment(this.sdate).subtract(1, 'months')
    },
    nextMonth() {
      this.sdate = moment(this.sdate).add(1, 'M')
    },
    withDateStyle: function(val) {
      //rd is rental duration
      var rd = moment(val.deliverydate).week()
      //console.log(rd)
      var lengthColor
      var otherCriterionColor
      if (rd === moment(new Date()).week()) {
        lengthColor = 'black'
        otherCriterionColor = 'orange'
      } else if (rd > moment(new Date()).week()) {
        lengthColor = 'black'
        otherCriterionColor = 'orange'
      } else if (rd < moment(new Date()).week()) {
        lengthColor = 'black'
        otherCriterionColor = 'orange'
      }
      if (val.status === 'ON HOLD') {
        lengthColor = 'black'
        otherCriterionColor = 'red'
      }
      if (val.status === 'Delivered') {
        lengthColor = 'white'
        otherCriterionColor = '#3C3F40'
      }
      return {
        color: lengthColor,
        background: otherCriterionColor
      }
    },


    deleteItem(item) {

      confirm('Are you sure you want to PERMANENTLY delete this item?')
      db.collection('history').doc(item.id).delete()
      this.$router.replace('history')


    },
    getInfo(item) {
      this.timelineIndex = this.orders.indexOf(item)
      this.timelineItem = Object.assign({}, item)

      this.drawer = true

    },
    restoreItem(item) {
      db.collection('history').doc(item.id).delete()
      db.collection('orders').add(item).then(() => {
        console.log('ADDED to db')

      })
      db.collection('orders').doc(item.id).update({
        status: 'Delivered',
        statusUname: uname,
        statusTime: moment(new Date()).format('YYYY-MM-DD HH:mm')
      }).then(() => {
        this.$emit('Delivered')
      })

    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },



  }
}
</script>
<style scoped>
/*table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
  padding: 0 5px;


}
.mytable table th {
    background-color: rgb(67, 106, 232);
    color: black;
}
.mytable table tr {
    background-color: rgba(12, 206, 28, 0.438);

} */
</style>
